/**
 * BrandSpinner — the Walktek mark as a loading indicator, drawn as a steering wheel.
 *
 * A thick rim, three heavy spokes at 120°, and a ring hub — the whole assembly
 * turning like a wheel being steered. A plain circle rotating about its own
 * centre looks motionless, so the rim reads as steady while the spokes carry
 * the motion, which is exactly how a real wheel reads when turned.
 *
 * Drawn as inline SVG rather than an image so it stays crisp at any size,
 * follows the theme, costs no network request, and can be held still for users
 * who ask for reduced motion.
 *
 * Geometry is polar out of a 100-unit box centred at (50,50). The three bands
 * deliberately overlap so the wheel reads as one solid object rather than
 * separate pieces:
 *
 *   rim    r 34.5 – 45.5  (r=40, stroke 11)
 *   spoke  r 14   – 38    (stroke 13) — overlaps the hub and reaches into the rim
 *   hub    r 7.5  – 16.5  (r=12, stroke 9) — a ring, not a disc
 *
 * Max extent is 95.5, so nothing clips at the viewBox edge.
 */

import React from 'react';

export default function BrandSpinner({ size = 120, className = '' }) {
  return (
    <svg
      className={`brand-spinner ${className}`.trim()}
      width={size}
      height={size}
      viewBox="0 0 100 100"
      role="img"
      aria-hidden="true"
      focusable="false"
    >
      <g className="brand-spinner-rotor" fill="none">
        {/* Painted back to front: rim, then spokes over its inner edge, then the
            hub ring over the spoke ends. */}
        <circle className="brand-spinner-rim" cx="50" cy="50" r="40" strokeWidth="11" />

        <g className="brand-spinner-spokes" strokeWidth="13" strokeLinecap="round">
          <line x1="50"   y1="36" x2="50"   y2="12" />
          <line x1="62.1" y1="57" x2="82.9" y2="69" />
          <line x1="37.9" y1="57" x2="17.1" y2="69" />
        </g>

        <circle className="brand-spinner-hub" cx="50" cy="50" r="12" strokeWidth="9" />
      </g>
    </svg>
  );
}
